<template>
  <div class="recycle">
    <section class="top-wrap">
      <div class="main-title">回收站</div>
    </section>
    <div>
      <el-form v-if="selection.length === 0" :inline="true" :model="formData" v-ps>
        <el-form-item label="工作表">
          <el-select v-model="selectSheet" @change="filterRecycleList" clearable>
            <el-option
              v-for="(item, index) in sheetDefs"
              :key="index"
              :label="item.name"
              :value="item.sheetId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="title" @input="filterRecycleList"></el-input>
        </el-form-item>
        <el-form-item label="操作人员">
          <user-selector
            v-model="selected"
            v-bind="$attrs"
            @select="filterRecycleList"
          ></user-selector>
        </el-form-item>
        <el-form-item label="操作时间">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="filterRecycleList"
            size="small"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div v-else class="batch-operation">
        <div>
          已选择
          <span class="count">{{ selection.command + " " + selection.length }}</span>
          条
        </div>
        <span class="line"></span>
        <div class="batch-btn-wrap">
          <base-button @click="restoreAll">恢复</base-button>
          <base-button @click="deleteComplete">彻底删除</base-button>
        </div>
      </div>
    </div>
    <base-table
      :data="tableData"
      :page-info="pageInfo"
      style="width: 100%; height:100%"
      @page-change="getRecycleList"
    >
      <el-table-column width="55">
        <template v-slot:header>
          <div class="selection-header">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <el-dropdown trigger="click" @command="handleChange" placement="bottom-start">
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="本页">选择本页数据</el-dropdown-item>
                <el-dropdown-item command="全部">选择全部数据</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <template v-slot="scope">
          <div :class="{ 'selection-wrapper': true, checked: scope.row.checked }" @click.stop>
            <el-checkbox
              v-model="scope.row.checked"
              @change="handleCheckOneChange(scope.row)"
            ></el-checkbox>
            <span v-tip class="idx">{{ scope.row.idx }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in recycleColumns"
        :key="index"
        :prop="item.type"
        :label="item.label"
        :min-width="item.width"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="preview(scope.row)">查看</el-button>
          <el-button type="text" size="small" @click="restore(scope.row)">恢复</el-button>
          <el-button type="text" size="small" @click="remove(scope.row)">彻底删除</el-button>
        </template>
      </el-table-column>
    </base-table>
    <base-dialog :visible.sync="restoreVisible" show-close>
      <template v-slot:header>
        <div>恢复记录</div>
      </template>
      <template>
        <el-checkbox v-model="restoreChecked" style="margin-top:20px">
          恢复记录同时，将关联单条的现关联数据替换为原关联数据
        </el-checkbox>
        <div style="margin: 20px 0">
          <span>注：关联多条，默认在现关联数据上增加原关联数据</span>
        </div>
      </template>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="restoreVisible = false">取消</el-button>
          <el-button type="primary" @click="restoreData">确定</el-button>
        </span>
      </template>
    </base-dialog>
    <detail-dialog
      :visible.sync="detailVisible"
      :data-id="sheetDataBak.data.id"
      :app-id="app.id"
      :sheetDataBak="sheetDataBak.data"
      :is-bak="true"
    ></detail-dialog>
  </div>
</template>
<script>
import { recycleColumns } from "./statics"
import { getSimpleSheetList } from "@/api/sheet/sheet"
import UserSelector from "@/components/FormControl/UserSelector"
import dj from "dayjs"
import BaseTable from "@/components/UIComponents/BaseTable"
import * as batchApi from "@/api/sheet/batch"
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "recycle",
  components: { UserSelector, BaseTable, BaseDialog, BaseButton },
  inject: ["app"],
  data() {
    return {
      recycleColumns,
      tableData: [],
      sheetDefs: [],
      selectSheet: "",
      title: "",
      formData: {},
      selected: [],
      selectedUser: [],
      value1: [],
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      selectTable: [],
      restoreVisible: false,
      restoreChecked: true,
      isSingle: false,
      singleSelect: {},
      detailVisible: false,
      sheetDataBak: {
        data: { id: "" }
      },
      checkAll: false,
      isIndeterminate: false,
      select: "本页",
      selection: {
        tableData: [],
        length: 0,
        command: ""
      }
    }
  },
  beforeCreate() {
    this.$options.components.DetailDialog = require("@/components/Sheet/DetailDialog").default
  },
  created() {
    getSimpleSheetList(this.app.id).then(sheetDefs => (this.sheetDefs = sheetDefs))
    this.getRecycleList()
  },
  computed: {
    bakIds() {
      if (this.isSingle) return [this.singleSelect.id]
      return this.selection.tableData.map(x => {
        return x.id
      })
    }
  },
  methods: {
    getRecycleList() {
      let data = {
        sheetId: this.selectSheet,
        title: this.title,
        userId: this.selected[0],
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize
      }
      if (this.value1 && this.value1.length >= 2) {
        data.startTime = dj(this.value1[0]).format("YYYY-MM-DD HH:mm:ss")
        data.endTime = dj(this.value1[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      }
      batchApi.getSheetDataBakList(data, this.app.id).then(res => {
        this.tableData = res.content.map((row, index) => {
          row.idx = (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + (index + 1) + ""
          row.checked = false
          return row
        })
        this.pageInfo.total = res.totalElements
      })
    },
    filterRecycleList() {
      this.pageInfo.currentPage = 1
      this.getRecycleList()
    },
    deleteComplete() {
      let all = this.selection.command === "全部"
      this.$confirm(
        "记录删除后无法恢复，请确认您和工作表成员都不再需要这些记录再行删除。",
        "彻底删除记录",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        batchApi.deleteSheetDataBak(this.bakIds, this.app.id, all).then(() => {
          this.$message.success("刪除成功")
          if (this.bakIds.length === this.tableData.length && this.pageInfo.currentPage > 1)
            this.pageInfo.currentPage -= 1
          this.getRecycleList()
          this.selection = this.$options.data().selection
          this.isIndeterminate = false
          this.checkAll = false
          this.isSingle = false
        })
      })
    },
    restoreAll() {
      if (this.selection.length > 20) return this.$message.error("无法操作大于20条数据")
      this.restoreVisible = true
    },
    restoreData() {
      batchApi.restoreSheetDataBak(this.bakIds, this.restoreChecked, this.app.id).then(() => {
        this.$message.success("恢复成功")
        if (this.bakIds.length == this.tableData.length && this.pageInfo.currentPage > 1)
          this.pageInfo.currentPage -= 1
        this.getRecycleList()
        this.checkAll = false
        this.isSingle = false
        this.isSingle = false
        this.restoreVisible = false
      })
    },
    restore(row) {
      this.isSingle = true
      this.singleSelect = row
      this.restoreVisible = true
    },
    remove(row) {
      this.isSingle = true
      this.singleSelect = row
      this.deleteComplete()
    },
    preview(row) {
      batchApi.getSheetDataBak(row.id, this.app.id).then(res => {
        this.sheetDataBak = res
        this.detailVisible = true
      })
    },
    handleChange(command) {
      this.select = command
      this.checkAll = true
      this.handleCheckAllChange(true)
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      this.tableData.forEach(item => {
        item.checked = val
      })
      let select = {}
      if (val) {
        if (this.select === "本页") {
          select = {
            tableData: this.tableData,
            length: this.tableData.length,
            command: this.select
          }
        } else {
          select = {
            tableData: [],
            length: this.pageInfo.total,
            command: this.select
          }
        }
      } else {
        this.select = "本页"
        select = {
          tableData: [],
          length: 0,
          command: "本页"
        }
      }
      this.selection = select
    },
    handleCheckOneChange() {
      let selectedData = []
      let totalCount = this.tableData.length
      let someStatusCount = 0
      this.tableData.forEach(item => {
        if (item.checked === true) {
          someStatusCount++
          selectedData.push(item)
        }
      })
      if (this.checkAll && this.select === "全部") {
        this.tableData.forEach(item => {
          item.checked = false
        })
        someStatusCount = 0
        this.checkAll = false
        selectedData = []
      } else {
        this.checkAll = totalCount === someStatusCount
      }
      this.isIndeterminate = someStatusCount > 0 && someStatusCount < totalCount
      this.selection = {
        tableData: selectedData,
        length: selectedData.length,
        command: "本页"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.recycle {
  display: flex;
  flex-flow: column;
  height: 100%;
  .operate {
    display: flex;
    align-items: center;
    .el-select {
      margin-left: 5px;
    }
  }
  .el-form {
    white-space: nowrap;
    margin-left: 15px;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .batch-operation {
    display: flex;
    align-items: center;
    margin-left: 15px;
    margin-bottom: 10px;
    height: 40px;
    line-height: 40px;
    position: relative;
    .count {
      color: #3e84e9;
      margin: 0 5px;
    }
    .line {
      width: 0;
      height: 28px;
      margin: 0 16px;
      border-left: 1px solid #dee1e6;
      overflow: hidden;
    }
    .batch-btn-wrap {
      display: flex;
      flex: 1;
      overflow: hidden;
      height: 30px;
      position: relative;
      ::v-deep {
        .base-button {
          height: 28px;
          padding: 0 18px;
        }
      }
    }
  }
  ::v-deep {
    .el-table {
      .selection-header {
        height: 23px;
        width: 33px;
        margin: auto;
      }
      .selection-wrapper {
        overflow: hidden;
        text-align: center;
        .el-checkbox {
          display: none;
        }
        &.checked,
        &:hover {
          .el-checkbox {
            display: inline;
          }
          .idx {
            display: none;
          }
        }
      }
      .el-table-column--selection {
        text-align: center;
      }
    }
    .el-range-editor--small.el-input__inner {
      width: 240px;
    }
    .user-scope-selector-container {
      margin: 4px 0;
      width: 200px;
      .value-wrapper {
        min-height: 30px;
      }
    }
  }
}
</style>
